import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-eligibility-create',
  templateUrl: './eligibility-create.component.html',
  styleUrls: ['./eligibility-create.component.scss']
})
export class EligibilityCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  coursename = null;
  submitted = false;
  public eligibilityForm: FormGroup;
  public courses = [];
  public editorContent: string = '';

  public editorConfig = {
    allowedContent: true, // disables filtering, keeps styles
    //extraAllowedContent: 'p(style);div(style);img(style); h1(style); h2(style); h3(style);h4(style); h5(style); h6(style); span(style);', // allows styles on specific tags
    extraAllowedContent: '*[style];', 
  };
  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/eligibilitybyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.eligibilityForm.patchValue({
              _id: data.data._id,
              course: data.data.course,
              coursename: data.data.coursename,
              title: data.data.title,
              description: data.data.description,
              seohidden: data.data.seohidden
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });
    

    this.http.get<any>(this.api_endpoint+'/courses/').subscribe(
        data => {
          this.courses = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });

    this.eligibilityForm = this.formBuilder.group({
      course: ['', Validators.required],
      title: ['', Validators.required],
      description: ['', Validators.required],
      coursename: [''],
      seohidden: [''],
      _id: ['']
    })
  }

  getcourses(value){
    this.http.get<any>(this.api_endpoint+'/coursebyid/'+value).subscribe(
      data => {
        
        this.eligibilityForm.patchValue({
          coursename: data.data.course,
        })
       
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }
  
  get f() { return this.eligibilityForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.eligibilityForm.invalid) {
      return;
    }

    
      // console.log(this.coursename);
    if(this.action == 'Submit'){

      

    var data = {
      "course" : this.eligibilityForm.value.course,
      "coursename" : this.eligibilityForm.value.coursename,
      "title" : this.eligibilityForm.value.title,
      "description" : this.eligibilityForm.value.description,
      "admin" : sessionStorage.getItem('adminName'),
       "seohidden": this.eligibilityForm.value.seohidden,
    };
    console.log(data);
    
    this.http.post<any>(this.api_endpoint+'/eligibility', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/eligibility/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
    }else{
      var data1 = {
        "course" : this.eligibilityForm.value.course,
        "coursename" : this.eligibilityForm.value.coursename,
        "title" : this.eligibilityForm.value.title,
        "description" : this.eligibilityForm.value.description,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.eligibilityForm.value._id,
        "seohidden": this.eligibilityForm.value.seohidden,
      };
        // console.log(data1);     
        this.http.put<any>(this.api_endpoint+'/eligibility/', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/eligibility/list-page');
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    }
  }

}
